@if (config.data != undefined && config.data.token != undefined) {
  <tableau-viz id='tableau-viz' src="{{config.data.link}}" token="{{config.data.token}}" width="100%" height="2500px" toolbar='top'>
  </tableau-viz>
}
